import { Col, Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { Ecommerce, Pricing } from "../../../Constant";
import BecomeMember from "./BecomeMember";
import SimplePricingCard from "./SimplePricingCard";

const PricingContainer = () => {
  return (
    <>
      <Breadcrumbs pageTitle={Pricing} parent={Ecommerce} title={Pricing} />
      <Container fluid>
        <Row>
          <Col sm="12">
            <BecomeMember/>
            <SimplePricingCard/>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default PricingContainer;
